(function () {
  function initHub(root) {
    if (!root || root.dataset.pshInit === 'true') return;
    root.dataset.pshInit = 'true';

    var categoryTabs = Array.prototype.slice.call(root.querySelectorAll('[data-psh-category]'));
    var subItems = Array.prototype.slice.call(root.querySelectorAll('[data-psh-sub]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-psh-card]'));
    var emptyEl = root.querySelector('[data-psh-empty]');
    if (!categoryTabs.length) return;

    function setActiveCategory(categoryKey) {
      categoryTabs.forEach(function (tab) {
        var active = tab.getAttribute('data-psh-category') === categoryKey;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      var firstSubKey = '';
      subItems.forEach(function (item) {
        var match = item.getAttribute('data-psh-parent') === categoryKey;
        item.hidden = !match;
        item.classList.toggle('is-active', false);
        item.setAttribute('aria-selected', 'false');
        if (match && !firstSubKey) {
          firstSubKey = item.getAttribute('data-psh-sub') || '';
        }
      });

      if (firstSubKey) {
        setActiveSub(firstSubKey);
      } else {
        cards.forEach(function (card) {
          card.hidden = true;
        });
        if (emptyEl) emptyEl.hidden = false;
      }
    }

    function setActiveSub(subKey) {
      subItems.forEach(function (item) {
        if (item.hidden) return;
        var active = item.getAttribute('data-psh-sub') === subKey;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      var visibleCount = 0;
      cards.forEach(function (card) {
        var match = card.getAttribute('data-psh-card') === subKey;
        card.hidden = !match;
        if (match) visibleCount += 1;
      });

      if (emptyEl) emptyEl.hidden = visibleCount > 0;
    }

    categoryTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setActiveCategory(tab.getAttribute('data-psh-category'));
      });
    });

    subItems.forEach(function (item) {
      item.addEventListener('click', function () {
        if (item.hidden) return;
        setActiveSub(item.getAttribute('data-psh-sub'));
      });
    });

    var initialCategory = '';
    categoryTabs.forEach(function (tab) {
      if (!initialCategory && tab.classList.contains('is-active')) {
        initialCategory = tab.getAttribute('data-psh-category') || '';
      }
    });
    if (!initialCategory && categoryTabs[0]) {
      initialCategory = categoryTabs[0].getAttribute('data-psh-category') || '';
    }
    if (initialCategory) setActiveCategory(initialCategory);
  }

  function initAll() {
    document.querySelectorAll('[data-product-support-hub]').forEach(initHub);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-product-support-hub]')
      : null;
    if (root) {
      delete root.dataset.pshInit;
      initHub(root);
    } else if (event.target && event.target.matches && event.target.matches('[data-product-support-hub]')) {
      delete event.target.dataset.pshInit;
      initHub(event.target);
    }
  });
})();
